export const TEXT = {
  en: {
    terminal: [
      '/home/ohnikx > Accessing Website...',
      '/home/ohnikx > Access Granted!',
      '/home/ohnikx > Please report any bug/suggestion in the discord server!',
      '/home/ohnikx > Upcoming Content Creator'
    ],
    equipmentTitle: 'My Setup',
    gameStatsTitle: 'Game Stats',
    recentVideoTitle1: 'Recent Video on Main Channel',
    recentVideoTitle2: 'Recent Video on Second Channel',
    socialLinksTitle: 'You can also find me here!',
    footerText: '© 2025 OhNikx. All rights reserved.',
    bugNoticeText: 'All Functional',
    headerMessages: [
      "Hello, user!",
      "Welcome in.",
      "Heya! Welcome in!",
      "Morning.",
      "Hello there, wild traveler."
    ],
    valorantLabels: {
      currentRank: 'Current Rank:',
      lastUpdated: 'Last Updated:',
      mains: 'Mains:',
      sensitivity: 'Sensitivity:'
    },
    osuLabels: {
      globalRank: 'Global Rank:',
      countryRank: 'Country Rank:',
      pp: 'PP:',
      accuracy: 'Accuracy:',
      keyboard: 'Keyboard:',
      tablet: 'Tablet:',
      aimingStyle: 'Aiming Style:'
    }
  },
  it: {
    terminal: [
      '/home/ohnikx > Accesso al sito...',
      '/home/ohnikx > Accesso consentito!',
      '/home/ohnikx > Per favore segnalate eventuali bug/suggerimenti nel server discord!',
      '/home/ohnikx > Sto imparando C, Python, HTML, Zsh e altro',
      '/home/ohnikx > Prossimo Content Creator'
    ],
    equipmentTitle: 'Il Mio Hardware',
    gameStatsTitle: 'Statistiche',
    recentVideoTitle1: 'Video Recente nel canale principale',
    recentVideoTitle2: 'Video Recente nel secondo canale',
    socialLinksTitle: 'Puoi trovarmi anche qui!',
    footerText: '© 2025 OhNikx. Tutti i diritti riservati.',
    bugNoticeText: 'Tutto Operativo',
    headerMessages: [
      "Ciao, utente!",
      "Benvenuto.",
      "Ehi! Benvenuto!",
      "Buongiorno.",
      "Salve, viaggiatore selvaggio."
    ],
    valorantLabels: {
      currentRank: 'Rank Attuale:',
      lastUpdated: 'Ultimo Aggiornamento:',
      mains: 'Mains:',
      sensitivity: 'Sensibilità:'
    },
    osuLabels: {
      globalRank: 'Rank Globale:',
      countryRank: 'Rank Nazionale:',
      pp: 'PP:',
      accuracy: 'Accuratezza:',
      keyboard: 'Tastiera:',
      tablet: 'Tablet:',
      aimingStyle: 'Stile di Mira:'
    }
  }
};
